import { NgIf } from '@angular/common';
import { Component, computed, Inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from 'ui-library';

type colors = 'primary' | 'secondary' | 'danger' | 'warning' | 'muted' | 'none' | 'outline';

@Component({
    selector: 'app-confirm',
    imports: [
        NgIf,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        ButtonComponent,
        TranslateModule
    ],
    standalone: true,
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss']
})

export class ConfirmComponent {
    cancelColor: colors = 'outline';
    cancelText: string = "Cancel";
    cancelIcon: string = "";

    okColor: colors = 'primary';
    okText: string = "Ok";
    okIcon: string = "";

    icon: string = "";

    /** Word the user has to type before the ok button unlocks. Empty means no typed confirmation. */
    confirmationWord: string = "";
    confirmationLabel: string = "";
    confirmationCaseSensitive: boolean = false;

    readonly confirmationInput = signal("");
    readonly confirmationValid = computed(() => {
        if (!this.confirmationWord) return true;

        const typed = this.confirmationInput().trim();

        return this.confirmationCaseSensitive
            ? typed === this.confirmationWord
            : typed.toLocaleLowerCase() === this.confirmationWord.toLocaleLowerCase();
    });

    constructor(
        public dialogRef: MatDialogRef<ConfirmComponent>,
        private translate: TranslateService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data.okColor) this.okColor = data.okColor;
        if (data.okText) this.okText = this.translate.instant(data.okText);
        if (data.okIcon) this.okIcon = data.okIcon;

        if (data.cancelColor) this.cancelColor = data.cancelColor;
        if (data.cancelText) this.cancelText = this.translate.instant(data.cancelText);
        if (data.cancelIcon) this.cancelIcon = data.cancelIcon;

        if (data.icon) this.icon = data.icon;

        if (data.confirmationWord) {
            this.confirmationWord = this.translate.instant(data.confirmationWord);
            this.confirmationCaseSensitive = !!data.confirmationCaseSensitive;
            this.confirmationLabel = this.translate.instant(
                data.confirmationLabel || 'form.type_to_confirm',
                {
                    word: this.confirmationCaseSensitive
                        ? this.confirmationWord
                        : this.confirmationWord.toLocaleLowerCase()
                }
            );
        }
    }

    dismiss(reason: string): void {
        if(reason === "cancelBtn") {
            this.data.cancel = true;
        }

        this.data.dismissed = true
        this.dialogRef.close(this.data);
    }

    ok(): void {
        if (!this.confirmationValid()) return;

        this.data.ok = true;
        this.dialogRef.close(this.data);
    }

}
